// extracted by mini-css-extract-plugin
export default {"button":"FiltrLibrary_button__VCYT-"};